const style = document.createElement("style");
style.innerHTML = `
  body {
    margin: 0;
    padding: 0;
    font-family: 'Segoe UI', sans-serif;
    background: #f5f7fa;
    color: #222;
  }

  h1, h2 {
    color: #1a2a3a;
  }

  button {
    background-color: #ffffff;
    color: #1a2a3a;
    border: 1px solid #ccc;
    padding: 10px 18px;
    border-radius: 8px;
    margin: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  button:hover {
    background-color: #f0f0f0;
  }

  .card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.05);
    padding: 24px;
    max-width: 500px;
    margin: 20px auto;
    font-size: 1.2rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  footer {
    text-align: center;
    font-size: 0.8rem;
    color: #777;
    background-color: #e9ecef;
    padding: 10px;
    margin-top: 50px;
    border-top: 1px solid #ccc;
  }
  body.dark-mode {
    background-color: #121212;
    color: #e0e0e0;
  }
  
  body.dark-mode h1,
  body.dark-mode h2 {
    color: #f0f0f0;
  }
  
  body.dark-mode button {
    background-color: #1f1f1f;
    color: #eee;
    border-color: #444;
  }
  
  body.dark-mode button:hover {
    background-color: #2c2c2c;
  }
  
  body.dark-mode .card {
    background: #1c1c1c;
    color: #eaeaea;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  
  body.dark-mode footer {
    background-color: #1a1a1a;
    color: #aaa;
    border-color: #444;
  }
  
`;
document.head.appendChild(style);

import React, { useState, useEffect } from "react";

const AMPDS = [
  { number: "1", name: "Bauchschmerzen, -beschwerden" },
  {
    number: "2",
    name: "Allergie (Überreaktion) / Kontakt mit Giftigen Tieren (Stiche, Bisse)",
  },
  { number: "3", name: "Tierbiss / Tierangriff" },
  { number: "4", name: "Körperverletzung / Sexualdelikt / Elektroschocker" },
  {
    number: "5",
    name: "Rückenschmerzen (Nicht Traumatische Rückenschmerzen Oder Ältere Verletzung)",
  },
  { number: "6", name: "Atembeschwerden" },
  {
    number: "7",
    name: "Verbrennungen (Verbrühungen) / Explosion (Detonation)",
  },
  { number: "8", name: "Kohlenmonoxid / Inhalation / Gefahrgut / CBRN" },
  { number: "9", name: "Kreislauf-, Atemstillstand / Tote Person" },
  {
    number: "10",
    name: "Brustschmerzen / Andere Beschwerden In Der Brust (Nicht Traumatisch)",
  },
  { number: "11", name: "Atemwegsverlegung" },
  { number: "12", name: "Krampfanfall" },
  { number: "13", name: "Blutzuckerentgleisungen" },
  {
    number: "14",
    name: "Ertrinken / Beinahe-Ertrinken / Kopfsprung / Gerätetauchunfall",
  },
  { number: "15", name: "Stromunfall / Blitzschlag" },
  { number: "16", name: "Augenprobleme / Verletzungen" },
  { number: "17", name: "Sturz / Absturz" },
  { number: "18", name: "Kopfschmerzen" },
  { number: "19", name: "Herzbeschwerden / Implantierter Defibrillator" },
  { number: "20", name: "Hitze-, Kälteprobleme" },
  { number: "21", name: "Blutung / Wunden" },
  {
    number: "22",
    name: "Unzugängliche / Verschüttete / Eingeklemmte / Eingeschlossene Person (Nicht Verkehrsbedingt)",
  },
  { number: "23", name: "Überdosis / Vergiftung (Einnahme)" },
  { number: "24", name: "Schwangerschaft / Geburt / Fehlgeburt" },
  { number: "25", name: "Psychiatrie / Abnormales Verhalten / Suizidversuch" },
  { number: "26", name: "Kranke Person (Spezielle Krankheitsbilder)" },
  { number: "27", name: "Stich-, Schuss-, Pfählungsverletzung" },
  {
    number: "28",
    name: "Schlaganfall / Transitorisch Ischämische Attacke (TIA)",
  },
  { number: "29", name: "Verkehrsunfälle" },
  { number: "30", name: "Verletzungen" },
  { number: "31", name: "Bewusstlosigkeit / Ohnmacht (Beinahe-)" },
  { number: "32", name: "Unklares Geschehen (Person In Notlage)" },
  {
    number: "33",
    name: "Anforderung Von Rettungsmittel Durch Versorgungseinrichtungen / Palliative Medizin / Einweisung",
  },
  { number: "34", name: "AUM (Automatische Unfallmeldung)" },
];

const FPDS = [
  { number: "51", name: "Flugnotfall (Luftfahrzeug)" },
  { number: "52", name: "Gefahrenmeldeanlage" },
  { number: "53", name: "Hilfeleistungen / Arbeitseinsätze" },
  { number: "54", name: "Einsturz / Verschüttung / Einschluss (Raumenge)" },
  { number: "55", name: "Stromgefahr" },
  { number: "56", name: "Aufzug- / Rolltreppen- / Fahrsteigunfall" },
  { number: "57", name: "Explosion" },
  {
    number: "58",
    name: "Befreiung / Eingeklemmte Person (Maschine, Fahrzeug – Kein Vu)",
  },
  { number: "59", name: "Treibstoff- / Ölaustritt Oder -Geruch" },
  { number: "60", name: "Gasaustritt / Gasgeruch (Erdgas Und Flüssiggas)" },
  { number: "61", name: "Gefahrgut" },
  { number: "62", name: "Höhen- / Tiefenrettung (Über Oder Unter Niveau)" },
  { number: "63", name: "Blitzschlag (Erkundung)" },
  { number: "64", name: "Schiffs- / Bootsbrand" },
  {
    number: "65",
    name: "Nachbarschaftshilfe / Unterstützung Anderer Organisationen",
  },
  { number: "66", name: "Geruch (Seltsam / Unbekannt)" },
  { number: "67", name: "Brand Im Freien" },
  { number: "68", name: "Rauchmeldung (Im Freien)" },
  { number: "69", name: "Gebäude- / Bauwerksbrand" },
  { number: "70", name: "Bahnkollision / Entgleisung" },
  { number: "71", name: "Fahrzeugbrand" },
  {
    number: "72",
    name: "Wasserrettung / Sinkendes Fahrzeug / Fahrzeug In Fliessgewässer",
  },
  { number: "73", name: "Wasserfahrzeug In Notlage / Kollision" },
  {
    number: "74",
    name: "Verdächtiges Paket (Brief, Gegenstand, Substanz) / Sprengstoffe",
  },
  { number: "75", name: "Bahnbrand" },
  { number: "76", name: "Bombendrohung" },
  { number: "77", name: "Fahrzeugkollision" },
  { number: "78", name: "Wetter (Umweltbedingte Vorfälle)" },
];

const allProtocols = [...AMPDS, ...FPDS];

function shuffle(array) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

const getStatus = (number) =>
  localStorage.getItem("status_" + number) || "neutral";
const setStatus = (number, status) =>
  localStorage.setItem("status_" + number, status);

const updateStats = (number, correct) => {
  const key = "quiz_stats_" + number;
  const stats = JSON.parse(localStorage.getItem(key)) || {
    correct: 0,
    wrong: 0,
  };
  correct ? stats.correct++ : stats.wrong++;
  localStorage.setItem(key, JSON.stringify(stats));
};
function LearnMode({ goBack }) {
  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [list] = useState(allProtocols);

  const current = list[index];
  const status = getStatus(current.number);

  const updateStatus = (s) => setStatus(current.number, s);

  return (
    <div>
      <button onClick={goBack}>🔙 Zurück</button>
      <h2>🧠 Lernmodus</h2>

      <div
        onClick={() => setFlipped(!flipped)}
        className="card"
        style={{ cursor: "pointer" }}
      >
        {flipped ? current.name : `Protokoll ${current.number}`}
      </div>

      <p>
        Status:{" "}
        {status === "known"
          ? "✅ Beherrsche ich"
          : status === "unsure"
          ? "❗ Unsicher"
          : "🟦 Offen"}
      </p>

      <div>
        <button onClick={() => updateStatus("known")}>✅ Beherrsche ich</button>
        <button onClick={() => updateStatus("unsure")}>❗ Unsicher</button>
      </div>

      <div>
        <button
          onClick={() => {
            setIndex((index - 1 + list.length) % list.length);
            setFlipped(false);
          }}
        >
          ⬅️ Zurück
        </button>
        <button
          onClick={() => {
            setIndex((index + 1) % list.length);
            setFlipped(false);
          }}
        >
          ➡️ Weiter
        </button>
      </div>
    </div>
  );
}
function LearnModeFiltered({ goBack }) {
  const filteredList = allProtocols.filter((p) => {
    const stats = JSON.parse(
      localStorage.getItem("quiz_stats_" + p.number) || "{}"
    );
    return stats.wrong > (stats.correct || 0);
  });

  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);

  if (filteredList.length === 0) {
    return (
      <div>
        <button onClick={goBack}>🔙 Zurück</button>
        <h2>🎯 Nur falsch beantwortete Protokolle</h2>
        <p>🎉 Super! Keine falsch beantworteten Protokolle vorhanden.</p>
      </div>
    );
  }

  const current = filteredList[index];
  const status = getStatus(current.number);
  const updateStatus = (s) => setStatus(current.number, s);

  return (
    <div>
      <button onClick={goBack}>🔙 Zurück</button>
      <h2>🎯 Nur falsche beantworten</h2>

      <div
        onClick={() => setFlipped(!flipped)}
        className="card"
        style={{ cursor: "pointer" }}
      >
        {flipped ? current.name : `Protokoll ${current.number}`}
      </div>

      <p>
        Status:{" "}
        {status === "known"
          ? "✅ Beherrsche ich"
          : status === "unsure"
          ? "❗ Unsicher"
          : "🟦 Offen"}
      </p>

      <div>
        <button onClick={() => updateStatus("known")}>✅ Beherrsche ich</button>
        <button onClick={() => updateStatus("unsure")}>❗ Unsicher</button>
      </div>

      <div>
        <button
          onClick={() => {
            setIndex((index - 1 + filteredList.length) % filteredList.length);
            setFlipped(false);
          }}
        >
          ⬅️ Zurück
        </button>
        <button
          onClick={() => {
            setIndex((index + 1) % filteredList.length);
            setFlipped(false);
          }}
        >
          ➡️ Weiter
        </button>
      </div>
    </div>
  );
}
function QuizMode({ goBack }) {
  const [questions] = useState(shuffle([...allProtocols]).slice(0, 10));
  const [index, setIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [selected, setSelected] = useState(null);
  const [results, setResults] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (index < questions.length) {
      const current = questions[index];
      const newOptions = shuffle([
        current,
        ...shuffle(
          allProtocols.filter((p) => p.number !== current.number)
        ).slice(0, 2),
      ]);
      setOptions(newOptions);
    }
  }, [index, questions]);

  if (index >= questions.length) {
    return (
      <div>
        <button onClick={goBack}>🔙 Zurück</button>
        <h2>🎉 Quiz beendet</h2>
        <p>
          Dein Ergebnis: {score} / {questions.length}
        </p>
        <h3>Antwortübersicht:</h3>
        <ul style={{ textAlign: "left", maxWidth: 500, margin: "auto" }}>
          {results.map((res, i) => (
            <li key={i}>
              {res.result} {res.question} – Deine Antwort: {res.selected},
              Richtig: {res.correct}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const current = questions[index];

  const handleAnswer = (number) => {
    const isCorrect = number === current.number;
    updateStats(current.number, isCorrect);

    const historyEntry = {
      name: current.name,
      number: current.number,
      correct: isCorrect,
      time: new Date().toISOString(),
    };
    const history = JSON.parse(localStorage.getItem("quiz_history") || "[]");
    history.push(historyEntry);
    localStorage.setItem("quiz_history", JSON.stringify(history));

    setResults([
      ...results,
      {
        question: current.name,
        selected: number,
        correct: current.number,
        result: isCorrect ? "✅" : "❌",
      },
    ]);

    if (isCorrect) setScore(score + 1);
    setSelected(number);
    setTimeout(() => {
      setSelected(null);
      setIndex(index + 1);
    }, 800);
  };

  return (
    <div>
      <button onClick={goBack}>🔙 Zurück</button>
      <h2>
        Frage {index + 1} von {questions.length}
      </h2>
      <p>
        <strong>{current.name}</strong>
      </p>
      {options.map((opt) => (
        <button
          key={opt.number}
          onClick={() => handleAnswer(opt.number)}
          disabled={selected !== null}
          style={{
            margin: "10px",
            padding: "10px 20px",
            backgroundColor:
              selected === null
                ? "#eee"
                : opt.number === current.number
                ? "#a8f0a1"
                : opt.number === selected
                ? "#f8a1a1"
                : "#eee",
          }}
        >
          {opt.number}
        </button>
      ))}
    </div>
  );
}
function Dashboard({ goBack, startFilteredLearn }) {
  const [filter, setFilter] = useState("all");

  const categorized = allProtocols.map((item) => {
    const status = getStatus(item.number);
    const stats = JSON.parse(
      localStorage.getItem("quiz_stats_" + item.number) || "{}"
    );

    return {
      ...item,
      status,
      correct: stats.correct || 0,
      wrong: stats.wrong || 0,
    };
  });

  const filtered = categorized.filter((p) => {
    if (filter === "all") return true;
    if (filter === "known") return p.status === "known";
    if (filter === "unsure") return p.status === "unsure";
    if (filter === "neutral") return p.status === "neutral";
    return true;
  });

  const resetStats = () => {
    allProtocols.forEach((p) => {
      localStorage.removeItem("status_" + p.number);
      localStorage.removeItem("quiz_stats_" + p.number);
    });
    window.location.reload();
  };

  return (
    <div>
      <button onClick={goBack}>🔙 Zurück</button>
      <h2>📊 Fortschrittsübersicht</h2>

      <div style={{ marginBottom: "1rem" }}>
        <button onClick={() => setFilter("all")}>🔁 Alle</button>
        <button onClick={() => setFilter("known")}>✅ Beherrsche ich</button>
        <button onClick={() => setFilter("unsure")}>❗ Unsicher</button>
        <button onClick={() => setFilter("neutral")}>🟦 Offen</button>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <button
          onClick={resetStats}
          style={{
            marginRight: "1rem",
            backgroundColor: "#f88",
            color: "#fff",
          }}
        >
          🧹 Alles zurücksetzen
        </button>
        <button
          onClick={startFilteredLearn}
          style={{ backgroundColor: "#88f", color: "#fff" }}
        >
          🎯 Nur falsch beantworten trainieren
        </button>
      </div>

      <table
        style={{ margin: "auto", borderCollapse: "collapse", width: "90%" }}
      >
        <thead>
          <tr style={{ borderBottom: "2px solid #ccc" }}>
            <th style={{ textAlign: "left", padding: "8px" }}>#</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Name</th>
            <th>Status</th>
            <th>✔️</th>
            <th>❌</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((p) => (
            <tr key={p.number} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "6px" }}>{p.number}</td>
              <td style={{ padding: "6px" }}>{p.name}</td>
              <td
                style={{
                  padding: "6px",
                  fontWeight: "bold",
                  color:
                    p.status === "known"
                      ? "green"
                      : p.status === "unsure"
                      ? "darkorange"
                      : "blue",
                }}
              >
                {p.status === "known"
                  ? "✅"
                  : p.status === "unsure"
                  ? "❗"
                  : "🟦"}
              </td>
              <td style={{ textAlign: "center" }}>{p.correct}</td>
              <td style={{ textAlign: "center" }}>{p.wrong}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
function QuizHistory({ goBack }) {
  const history = JSON.parse(localStorage.getItem("quiz_history") || "[]");

  return (
    <div>
      <button onClick={goBack}>🔙 Zurück</button>
      <h2>📚 Quizverlauf</h2>
      {history.length === 0 ? (
        <p>Keine gespeicherten Quizantworten vorhanden.</p>
      ) : (
        <table
          style={{ width: "90%", margin: "auto", borderCollapse: "collapse" }}
        >
          <thead>
            <tr style={{ borderBottom: "2px solid #ccc" }}>
              <th style={{ padding: "8px", textAlign: "left" }}>Zeit</th>
              <th style={{ padding: "8px", textAlign: "left" }}>#</th>
              <th style={{ padding: "8px", textAlign: "left" }}>Protokoll</th>
              <th>Ergebnis</th>
            </tr>
          </thead>
          <tbody>
            {history.reverse().map((entry, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "6px" }}>
                  {new Date(entry.time).toLocaleString()}
                </td>
                <td style={{ padding: "6px" }}>{entry.number}</td>
                <td style={{ padding: "6px" }}>{entry.name}</td>
                <td
                  style={{
                    padding: "6px",
                    color: entry.correct ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {entry.correct ? "✅ Richtig" : "❌ Falsch"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
export default function App() {
  const [mode, setMode] = useState("menu");

  return (
    <div
      style={{
        fontFamily: "Segoe UI, sans-serif",
        textAlign: "center",
        padding: "2rem",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <h1>🚨 ProQA Lern-App</h1>

      {mode === "menu" && (
        <div style={{ marginTop: "2rem" }}>
          <button onClick={() => setMode("learn")} style={btnStyle}>
            🧠 Lernmodus starten
          </button>
          <br />
          <button onClick={() => setMode("quiz")} style={btnStyle}>
            🎯 Quizmodus starten
          </button>
          <br />
          <button onClick={() => setMode("dashboard")} style={btnStyle}>
            📊 Fortschritt anzeigen
          </button>
          <br />
          <button onClick={() => setMode("history")} style={btnStyle}>
            📚 Quizverlauf
          </button>
          <br />
          <button onClick={() => setMode("learn_filtered")} style={btnStyle}>
            🎯 Nur falsche trainieren
          </button>
        </div>
      )}

      {mode === "learn" && <LearnMode goBack={() => setMode("menu")} />}
      {mode === "quiz" && <QuizMode goBack={() => setMode("menu")} />}
      {mode === "dashboard" && (
        <Dashboard
          goBack={() => setMode("menu")}
          startFilteredLearn={() => setMode("learn_filtered")}
        />
      )}
      {mode === "history" && <QuizHistory goBack={() => setMode("menu")} />}
      {mode === "learn_filtered" && (
        <LearnModeFiltered goBack={() => setMode("menu")} />
      )}

      <Footer />
    </div>
  );
}

const btnStyle = {
  padding: "12px 24px",
  margin: "0.5rem",
  fontSize: "1rem",
  background: "#ffffff",
  border: "1px solid #ccc",
  borderRadius: "6px",
  cursor: "pointer",
  transition: "all 0.2s ease",
};
function Footer() {
  return (
    <footer
      style={{
        textAlign: "center",
        fontSize: "0.8rem",
        color: "#777",
        backgroundColor: "#e9ecef",
        padding: "10px",
        marginTop: "50px",
        borderTop: "1px solid #ccc",
      }}
    >
      © DRK Bodensee-Oberschwaben gGmbH – entwickelt von Marius Thies –
      Testbetrieb – nicht für die Veröffentlichung!
    </footer>
  );
}
